import CreateAccount from './CreateAccount'
import { prop } from 'ramda'
import { connect } from 'react-redux'

const mapStateToProps = ({ authentication }) => ({
  email: prop('email', authentication),
  password: prop('password', authentication),
  revalidation: prop('revalidation', authentication),
})

export default connect(mapStateToProps)(CreateAccount)
